import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import AppShell from './components/AppShell'
import Login from './pages/Login'
import Home from './pages/Home'
import Audits from './pages/Audits'
import NewAudit from './pages/NewAudit'
import AuditDetail from './pages/AuditDetail'
import Admin from './pages/Admin'
import Reports from './pages/Reports'
import WeeklyReport from './pages/WeeklyReport'
import Dashboard from './pages/Dashboard'
import Account from './pages/Account'
import Programs from './pages/Programs'
import ProgramDetail from './pages/ProgramDetail'
import Tickets from './pages/Tickets'
import TicketDetail from './pages/TicketDetail'
import Dispatch from './pages/Dispatch'
import RemoteSessions from './pages/RemoteSessions'
import Sites from './pages/Sites'
import SiteDetail from './pages/SiteDetail'
import FleetDashboard from './pages/FleetDashboard'

function ProtectedRoutes() {
  const { user, loading } = useAuth()
  if (loading) return (
    <div className="loading-screen">
      <div className="spinner" />
      <span>Loading...</span>
    </div>
  )
  if (!user) return <Login />
  return (
    <AppShell>
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/audits"        element={<Audits />} />
        <Route path="/audits/new"    element={<NewAudit />} />
        <Route path="/audits/:id"    element={<AuditDetail />} />
        <Route path="/programs"           element={<Programs />} />
        <Route path="/programs/:slug"     element={<ProgramDetail />} />
        <Route path="/tickets"            element={<Tickets />} />
        <Route path="/tickets/:id"        element={<TicketDetail />} />
        <Route path="/sites"              element={<Sites />} />
        <Route path="/sites/:id"          element={<SiteDetail />} />
        <Route path="/dispatch"           element={<Dispatch />} />
        <Route path="/remote-sessions"    element={<RemoteSessions />} />
        <Route path="/dashboard"     element={<Dashboard />} />
        <Route path="/fleet"         element={<FleetDashboard />} />
        <Route path="/reports/weekly" element={<WeeklyReport />} />
        <Route path="/reports"       element={<Reports />} />
        <Route path="/admin"         element={<Admin />} />
        <Route path="/account"       element={<Account />} />
        <Route path="*"              element={<Navigate to="/" />} />
      </Routes>
    </AppShell>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProtectedRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
